import { isRoute } from '../../routeStore/functions/isRoute';
import { DashboardVehicle } from '../types/DashboardVehicle';
import { shouldConfirmVehicle } from './shouldConfirmVehicle';
import { toDashboardRedirect } from './toDashboardRedirect';

export const getVehicleRouteRedirect = (
  url: string,
  vehicle: DashboardVehicle | null,
  vehicleId: string | undefined,
  hasDuplicateApplication?: string | null,
): Response | null => {
  // an unconfirmed vehicle has no application to show yet. The id is passed through
  // verbatim because these routes accept an autopay number as well as a uuid
  if (isRoute(url, '/dashboard/application/:vehicleId')) {
    return shouldConfirmVehicle(vehicle)
      ? toDashboardRedirect(`/update-vehicle/${vehicleId}`, url)
      : null;
  }

  // nothing left to confirm. A vehicle that could not be resolved stays put, so the
  // page can show its own failure state instead of bouncing to the garage
  if (isRoute(url, '/update-vehicle/:vehicleId')) {
    return vehicle && !shouldConfirmVehicle(vehicle)
      ? toDashboardRedirect('/dashboard/garage', url)
      : null;
  }

  // this route is only reachable while the duplicate application parameter is live,
  // and the vehicle must be confirmed before telling the applicant about the
  // duplicate. Unlike the other two routes, a vehicle that could not be resolved has
  // nothing to show here either, so it also goes to the garage rather than rendering
  if (isRoute(url, '/duplicate-application')) {
    if (hasDuplicateApplication !== 'true' || !vehicle) {
      return toDashboardRedirect('/dashboard/garage', url);
    }

    return shouldConfirmVehicle(vehicle)
      ? toDashboardRedirect(`/update-vehicle/${vehicleId}`, url)
      : null;
  }

  return null;
};
